import React from 'react';
import { withStyles } from "tss-react/mui";
import withMediaQuery from 'components/WithMediaQuery';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';

import ResponsiveDialogHeader from 'components/ResponsiveDialogHeader';
import { default as FloatingDialogActions } from 'components/DialogActions';
import PrimaryDialogButton from 'components/PrimaryDialogButton';
import SecondaryDialogButton from 'components/SecondaryDialogButton';
import ScheduledCompetencyList from '../ScheduledCompetencyList';
import AwardableCompetenceList from '../AwardableCompetenceList';
import { Subtitle2, Body1 } from 'components/Typography';
import { isDefined } from 'utilities/is';
import { expiryIds } from '../../domain';
import styles from './styles';
import m from 'messages';

const ITEM_HEIGHT = 48;

class CompetenceSelectionDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedCompetence: null,
            showPending: Boolean(props.showPending),
            anchorEl: null,
            expiryDate: null
        };
    }

    canProceed = () => {
        const { selectedCompetence } = this.state;

        if (selectedCompetence === null) return false;

        // If the selected competence is a scheduled one, look up the associated competence it refers
        // to in order to check whether the expiry must be set
        if (Boolean(selectedCompetence && selectedCompetence.expiryID)) {
            if (selectedCompetence.expiryID.toUpperCase() === expiryIds.SPECIFY_EXPIRY_DATE) {
                return Boolean(this.state.expiryDate);
            }
        }

        return true;
    };

    handleProceed = () => this.props.handleSelection(this.state.selectedCompetence, this.state.expiryDate);

    handleCompetencySelected = (sc) => this.setState({ selectedCompetence: sc });

    handleExpiryDateSet = (date) => this.setState({ expiryDate: date });

    pendingCompetencies = () => {
        return (
            <div>
                <div>
                    <Body1 className={this.props.classes.scheduledDetails}>{m.competencies.scheduledDetails}</Body1>
                </div>
                <div className={this.props.classes.contentBody}>
                    <ScheduledCompetencyList
                        competencyClicked={this.handleCompetencySelected}
                        scheduledCompetencies={this.props.scheduledSiteCompetencies}
                        onSecondaryAction={this.handleMenuRequest}
                        handleExpiryDateSet={this.handleExpiryDateSet}
                        shouldShowSecondary={(sc) => !isDefined(sc.award)} />
                </div>
            </div>
        );
    };

    awardableCompetencies() {
        return (
            <div>
                <div>
                    <Body1 className={this.props.classes.scheduledDetails}>{m.competencies.scheduledDetails}</Body1>
                </div>
                <div className={this.props.classes.contentBody}>
                    <AwardableCompetenceList
                        divisionData={this.props.divisionData}
                        location={this.props.location}
                        card={this.props.card}
                        competencyClicked={this.handleCompetencySelected}
                        handleExpiryDateSet={this.handleExpiryDateSet}
                    />
                </div>
            </div>
        );
    }

    selectPendingTab = () => this.setState({ selectedCompetence: null, showPending: true, expiryDate: null });

    selectAvailableTab = () => this.setState({ selectedCompetence: null, showPending: false, expiryDate: null });

    handleMenuClose = () => this.setState({ anchorEl: null, selectedCompetence: null });

    markAsComplete = () => {
        const { selectedCompetence } = this.state;
        this.handleMenuClose();
        this.props.handleCompetenceCompletion(selectedCompetence);
    };

    handleMenuRequest = (event, sc) => {
        this.setState({
            anchorEl: event.currentTarget,
            selectedCompetence: sc
        });
    };

    chooser() {
        const showPending = Boolean(this.state.showPending);

        return (
            <div className={this.props.classes.chooserPanel}>
                <Subtitle2 paragraph>
                    Competency type
                </Subtitle2>
                <Grid container justifyContent="flex-start" alignItems="center" spacing={2} className={this.props.classes.chipContainer}>
                    <Chip
                        onClick={this.selectAvailableTab}
                        className={this.props.classes.chip}
                        color={!showPending ? 'primary' : 'default'}
                        variant="outlined"
                        label="Available" />
                    <Chip
                        onClick={this.selectPendingTab}
                        className={this.props.classes.chip}
                        color={showPending ? 'primary' : 'default'}
                        variant="outlined"
                        label="Scheduled" />
                </Grid>
            </div>
        );
    }

    contextMenu = () => {
        const { anchorEl } = this.state;
        const menuOpen = Boolean(anchorEl);

        return (
            <Menu
                id="removeMenu"
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={this.handleMenuClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: 200
                    }
                }}>
                <MenuItem onClick={this.markAsComplete} className={this.props.classes.menuItem}>
                    Mark as complete
                </MenuItem>
            </Menu>
        );
    };

    render() {
        const { classes, fullScreen } = this.props;
   
        const showPending = Boolean(this.state.showPending);

        return (
            <Dialog open={this.props.open} fullScreen={fullScreen} className={classes.dialogRoot}>

                <ResponsiveDialogHeader
                    fullScreen={fullScreen}
                    title="Choose competency"
                    handleClose={this.props.handleClose} />

                <DialogContent className={classes.dialogContent}>
                    {this.chooser()}
                    {this.contextMenu()}
                    {!showPending &&
                        this.awardableCompetencies()
                    }
                    {showPending &&
                        this.pendingCompetencies()
                    }
                </DialogContent>
                {fullScreen &&
                    <DialogActions>
                        <PrimaryDialogButton disabled={!this.canProceed()} onClick={this.handleProceed}>Proceed</PrimaryDialogButton>
                    </DialogActions>
                }
                {!fullScreen &&
                    <FloatingDialogActions fullScreen={false}>
                        <SecondaryDialogButton onClick={this.props.handleClose}>Cancel</SecondaryDialogButton>
                        <PrimaryDialogButton disabled={!this.canProceed()} onClick={this.handleProceed}>Proceed</PrimaryDialogButton>
                    </FloatingDialogActions>
                }

            </Dialog>
        );
    }
}

const Media = withMediaQuery(theme => theme.breakpoints.down('lg'))(CompetenceSelectionDialog);
export default withStyles(Media,styles);
